/** Small formatting helpers for the threat queue. */

const pad = (n) => String(n).padStart(2, '0');
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** "15 Oct 22:06 UTC" (SOC teams correlate in UTC). Accepts ms or an ISO string. */
export function formatUtcShort(value) {
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return `${d.getUTCDate()} ${MONTHS[d.getUTCMonth()]} ${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())} UTC`;
}

/** An owner as the queue shows it: "You" for the signed-in user (the only possible owner today). */
export function ownerView(owner, me) {
  if (!owner) return null;
  const mine = owner.owner_id === 'pending' || (me && owner.owner_id === me.id);
  const email = mine ? me?.email : owner.owner_email;
  return { label: mine ? 'You' : email || 'A teammate', initials: (email || '?').slice(0, 2).toUpperCase(), mine };
}
